import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { theme } from '../../../theme/theme'
import { BodyLarge, Title3 } from '../../../components/styles/Typography'
import { OnClickButton } from '../../../components/buttons/onclick/OnClickButton'
import { downloadFile } from '../../../utils/downloadFile'
import { ImageSkeleton } from '../../../components/ImageSkeleton'
import { useGetAssetById } from '../../../api/contentful/contentfulQueries'
import { parseContenfulImageUrl } from '../../../contentful/utils'

const REPORT_PREVIEW_IMAGE_ASSET_ID = '4OTSajFmuXpidAGeXbljuN'

type Props = {
  reportUrl: string
}

export const ReportCard = ({ reportUrl }: Props) => {
  const { t } = useTranslation()
  const { data: previewImageAsset, isLoading: isPreviewImageLoading } = useGetAssetById(REPORT_PREVIEW_IMAGE_ASSET_ID)
  const previewImageUrl = previewImageAsset
    ? parseContenfulImageUrl(previewImageAsset, { width: 1500, height: 1500 })
    : undefined

  return (
    <Card>
      <PreviewFrame>
        {isPreviewImageLoading || !previewImageUrl ? (
          <ImageSkeleton />
        ) : (
          <PreviewImage src={previewImageUrl} alt={t('admin.certification.reportTitle')} />
        )}
      </PreviewFrame>
      <CardContent>
        <Title3>{t('admin.certification.reportTitle')}</Title3>
        <BodyLarge>{t('admin.certification.reportDescription')}</BodyLarge>
        <BodyLarge>{t('admin.certification.reportDownloadCta')}</BodyLarge>
        <OnClickButton
          text={t('admin.certification.downloadReport')}
          onClick={() => downloadFile(reportUrl, 'certification-report.pdf')}
        />
      </CardContent>
    </Card>
  )
}

const Card = styled.div`
  display: flex;
  gap: ${theme.spacing.xlarge}px;
  background-color: ${theme.color.beigeLight};
  border-radius: ${theme.spacing.medium}px;
  padding: ${theme.spacing.large}px;
  @media screen and (max-width: ${theme.breakpoint.large}px) {
    flex-direction: column;
    gap: ${theme.spacing.medium}px;
  }
`

const PreviewFrame = styled.div`
  min-width: 45%;
  max-width: 600px;
  @media screen and (max-width: ${theme.breakpoint.medium}px) {
    width: 100%;
    max-width: none;
    flex: none;
  }
`

const PreviewImage = styled.img`
  width: 100%;
  object-fit: cover;
`

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: ${theme.spacing.small}px;
`
